<template>
  <router-view />
</template>

<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { Platform } from 'quasar';
import { Utils } from '@/composables/utils';
import { loadMSAPChat, removeMSAPChat } from '@/composables/msapChat';

console.log(process.env.VUE_APP_ENVIRONMENT);

const route = useRoute();
const isPc = !Platform.is.mobile;

// 라우트 변경 감시: 로그인 여부 + 경로에 따라 채팅 위젯 제어 (PC만)
watch(
  () => ({ path: route.path, token: Utils.getSessionStorage('token') }),
  ({ path, token }) => {
    if (!isPc || !token || path === '/login' || path.startsWith('/print')) {
      removeMSAPChat();
    } else {
      loadMSAPChat();
    }
  },
  { immediate: true }
);
</script>
